import {Component, OnInit} from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';

import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';
import {Banks} from '../../../shared/models/Banks.enum';

@Component({
    templateUrl: './upload-mt940-file.component.html',
    styleUrls: ['./upload-mt940-file.component.css']
})

/**
 * Component for uploading the mt940 file.
 *
 * @author mukesh.kumara@vernuso.com (Mukesh Kumar)
 */
export class UploadMt940FileComponent implements OnInit {

    enableSubmitButton: boolean = false;
    fileEvent: any;
    selectedEntity: any;
    headerSearchURI = ConstantsService.CLIENT_SEARCH;
    searchPlaceholder = MessageService.CLIENT_SEARCH_PLACEHOLDER;
    entityId: number;
    bankList: Array<Banks> = [];
    bank: string = Banks[Banks.ABN];
    Banks: typeof Banks = Banks;

    constructor(
        public dialogRef: MdDialogRef<UploadMt940FileComponent>,
        private snackBarService: SnackBarService,
        private cookieService: CookieService) {
    }

    ngOnInit () {
      this.bankList.push(Banks.ABN);
      this.bankList.push(Banks.KNAB);
    }

    fileChange(event) {
        this.fileEvent = event;
        this.enableSubmitButton = this.entityId != null;
    }

    /**
     * This is not the ideal way to upload the file. This code is written to support the jersey 1.X version on backend.
     * Because when we use the http module of angular 2 then it doesn't send the boundary content type in request and it
     * results into 500 and 400 request on backend.
     */
    uploadFile() {
        let fileList: FileList = this.fileEvent.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];

            let formData: FormData = new FormData();
            formData.append('file', file, file.name);
            formData.append('entityId', this.entityId);
            formData.append('bank', this.bank);

            const url = ConstantsService.APP_BE_URL + ConstantsService.UPLOAD_MT940_FILE_URL;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this.callSnackBarService(JSON.parse(xhr.response));
                        this.enableSubmitButton = false;
                        this.dialogRef.close();
                    } else {
                        this.callSnackBarService(JSON.parse(xhr.response));
                    }
                }
            };

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Authorization',
                'Bearer ' + this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN));
            xhr.setRequestHeader('app-type', 'TRUST');
            xhr.send(formData);
        }
    }

    private callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response, MessageService.UPLOAD_FILE_SUCCESS, MessageService.UPLOAD_FILE_FAILURE);
    }

    onEntitySelection(searchDetails: GenericSearchDetails) {
        this.entityId = searchDetails.entityId;
        this.selectedEntity = searchDetails.clientName;
        this.enableSubmitButton = this.fileEvent != null;
    }
}



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/uploadmt940file/upload-mt940-file.component.ts